module.exports = __webpack_public_path__ + "528887d41697beef5193f4e7b87f1b73.pdf";